export class LoadLifecycleHardwareOptions {
  public static readonly type = '[Employee Lifecycle Metadata] Load Hardware Options';
}

export class LoadLifecycleAssistSupportGroups {
  public static readonly type = '[Employee Lifecycle Metadata] Load Assist Support Groups';
}

export class LoadLifecycleMailboxes {
  public static readonly type = '[Employee Lifecycle Metadata] Load Mailboxes';
}

export class LoadLifecycleDistributionLists {
  public static readonly type = '[Employee Lifecycle Metadata] Load Distribution Lists';
}

export class LoadLifecycleServiceLanes {
  public static readonly type = '[Employee Lifecycle Metadata] Load Service Lanes';
}

export class LoadLifecycleServiceLaneTaskTypes {
  public static readonly type = '[Employee Lifecycle Metadata] Load Service Lane Task Types';
}
